module.exports = __webpack_public_path__ + "img/cloud-showers-heavy.0e7c8439.svg";